import { render, staticRenderFns } from "./VssCourseDialog.vue?vue&type=template&id=3aff8014&scoped=true&"
import script from "./VssCourseDialog.vue?vue&type=script&lang=js&"
export * from "./VssCourseDialog.vue?vue&type=script&lang=js&"
import style0 from "./VssCourseDialog.vue?vue&type=style&index=0&id=3aff8014&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aff8014",
  null
  
)

export default component.exports